// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Small } from '@finect/tabular-core/Small';
import { Flex } from '@finect/tabular-core/Flex';
import { User } from '@finect/tabular-icons/user';
import { MessageSquare } from '@finect/tabular-icons/messageSquare';

const StatsInfo = styled(Flex)`
  small {
    padding: 0 12px 0 5px;
    margin-right: 12px;
    line-height: 24px;

    &:not(:last-child) {
      border-right: 1px solid ${({ theme }) => theme.borderColor};
    }
  }

  svg {
    color: ${({ theme }) => theme.secondaryColor};
  }

  > * {
    margin-top: 6px;
  }

  > div {
    margin-left: 0;
  }
`;

type Props = {
  stats: {
    questions: number | null,
    followers: number | null
  },
  children?: any
};

export const Stats = ({ stats, children }: Props) => (
  <StatsInfo align="center" wrap="wrap">
    {stats.followers !== null ? (
      <Fragment>
        <User size="16" strokeWidth="2.4" />
        <Small light>
          {stats.followers} seguidor{stats.followers !== 1 && 'es'}
        </Small>
      </Fragment>
    ) : null}
    {stats.questions !== null ? (
      <Fragment>
        <MessageSquare size="16" strokeWidth="2.4" />
        <Small light>
          {stats.questions} pregunta{stats.questions !== 1 && 's'}
        </Small>
      </Fragment>
    ) : null}
    {children}
  </StatsInfo>
);
